import { render, staticRenderFns } from "./xw-price.vue?vue&type=template&id=e55cc4ac&scoped=true"
import script from "./xw-price.vue?vue&type=script&lang=js"
export * from "./xw-price.vue?vue&type=script&lang=js"
import "./xw-price.vue?vue&type=style&index=0&id=e55cc4ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e55cc4ac",
  null
  
)

export default component.exports